/*
 * Authors: Jakub, mariushirjanu
 * Created: 11/12/2020
 */
import * as _ from 'underscore';
import { Component, OnInit } from '@angular/core';
import { ICodeValue, ICompanyCountry, IContact, ICountry, IWebshop } from '../../../../type_definitions/datatypes';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';
import { WebshopRoleDataService } from './webshop-role-data.service';
import { FormattingService } from '../../../shared/services/formatting.service';
import { DefaultFormDialogComponent } from '../../../shared/message/dialogs/default-form-dialog.component';
import { TranslationService } from '../../../shared/translation/translation.service';

interface IWebshopRoleAdd {
  webshop?:IWebshop;
  roleType?:ICodeValue;
  role?:string;
  country?:ICountry;
  companyCountry?:ICompanyCountry;
  contact?:IContact;
}

@Component({
  selector: 'webshop-role-add',
  templateUrl: '../../../shared/message/dialogs/default-form-dialog.html'
})
export class WebshopRoleAddComponent extends DefaultFormDialogComponent implements OnInit {
  public model:IWebshopRoleAdd;
  private webshopId:number;
  private countryId:number;
  private webshopField:IExtraFieldConfigurationObject;
  private roleTypeField:IExtraFieldConfigurationObject;
  private roleField:IExtraFieldConfigurationObject;
  private countryField:IExtraFieldConfigurationObject;
  private companyCountryField:IExtraFieldConfigurationObject;
  private contactField:IExtraFieldConfigurationObject;

  constructor(
    validateService:GaValidateService,
    translationService:TranslationService,
    private webshopRoleDataService:WebshopRoleDataService,
    private formattingService:FormattingService,
    private formlyService:GaFormlyService
  ) {
    super(validateService, translationService);
  }

  public ngOnInit():void {
    this.entity = this.title;
    super.ngOnInit();

    this.webshopId = parseInt(this.queryFilters.Webshop_id);
    this.countryId = parseInt(this.queryFilters.Country);

    this.fields = this.createFields();
    this.webshopRoleDataService.webshop(this.webshopId)
      .then((webshop:IWebshop) => {
        this.model = { webshop };
      })
      .then(this.fillFields);
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.webshopField = this.formlyService.aValue('webshop', 'GA.GENERAL.WEBSHOP')
        .withoutEditable()
        .withFormat(this.formattingService.formatName)
        .build(),

      this.roleTypeField = this.formlyService.aSelect('roleType')
        .isRequired()
        .withFormat(this.formattingService.formatLov)
        .onChange((roleType:ICodeValue) => {
          this.formlyService.fillField(this.roleField, this.webshopRoleDataService.webshopRoles(this.webshopId, roleType.id), true);
          // if we already have a fixed country, we need to load the company countries
          this.loadCompanyCountries();
        })
        .build(),

      this.roleField = this.formlyService.aSelect('role')
        .isRequired()
        .build(),

      this.countryField = this.formlyService.aSelect('country', 'GA.GENERAL.COUNTRY')
        .isRequired()
        .withoutEditable()
        .withFormat(this.formattingService.formatCountry)
        .onChange(this.loadCompanyCountries)
        .build(),

      this.companyCountryField = this.formlyService.aSelect('companyCountry', 'GA.GENERAL.COMPANY')
        .isRequired()
        .withoutEditable()
        .withoutEditable()
        .withFormat(this.formattingService.formatCompanyCountryNick)
        .onChange((companyCountry:ICompanyCountry) => {
          this.formlyService.fillField(this.contactField, this.webshopRoleDataService.webshopsRolesUsers(companyCountry.company.id), true);
        })
        .build(),

      this.contactField = this.formlyService.aSelect('contact', 'GA.GENERAL.CONTACT')
        .isRequired()
        .withoutEditable()
        .withFormat(this.formattingService.formatContact)
        .build(),

      this.formlyService.aCheckbox('mainContact')
        .build()
    ];
  }

  private fillFields = ():void => {
    this.formlyService.fillField(this.roleTypeField, this.webshopRoleDataService.webshopRolesTypes(), true);

    this.formlyService.fillField(this.countryField, this.webshopRoleDataService.webshopRolesCountries(this.webshopId)
      .then((countries:ICountry[]) => {
        const country:ICountry = _.findWhere(countries, { id: this.countryId });
        this.form.patchValue({ country });
        if(!country && countries?.length === 1){
          this.form.patchValue({ country: countries[0] });
        }

        this.loadCompanyCountries();
        return countries;
      }));
  };

  private loadCompanyCountries = ():void => {
    if (this.model.country && this.model.roleType) {
      this.formlyService.fillField(this.companyCountryField, this.webshopRoleDataService.getWebshopRolesCompanyCountries(this.webshopId, this.model.country.id, this.model.roleType.id), true);
    }
  };
}